import React from 'react';

import { CategoriesTypeOption } from 'types/graphql';
import { MenuCustomizationData } from 'src/dispensary-admin/customize/data-access';
import { useDispensary } from 'src/hooks/use-dispensary';
import { getCategoryLabels } from 'src/dispensary-admin/customize/customize.utils';
import { TextList } from './lists/text-list';
import { CompactList } from './lists/compact-list';
import { StackedList } from './lists/stacked-list';
import { LargeList } from './lists/large-list';
import { ListProps } from './lists/list.types';

type CategoriesV2Props = {
  settings: MenuCustomizationData['categoriesV2'];
};

export const getListComponent = (type: CategoriesTypeOption): React.ComponentType<ListProps> => {
  switch (type) {
    case CategoriesTypeOption.text:
      return TextList;
    case CategoriesTypeOption.compact:
      return CompactList;
    case CategoriesTypeOption.stacked:
      return StackedList;

    // Large type is the existing component, so we will consider that the default
    default:
      return LargeList;
  }
};

export const CategoriesV2 = ({ settings }: CategoriesV2Props): JSX.Element => {
  const { items, mobileDisplay, style, type } = settings;
  const dispensary = useDispensary();
  const categoryLabels = getCategoryLabels(dispensary.location?.state);

  // Get the correct category labels for preview
  const categories = items.map(({ category, image }) => ({
    category: categoryLabels?.[category] ?? category,
    image,
  }));

  const ListComponent = getListComponent(type);

  return <ListComponent items={categories} mobileDisplay={mobileDisplay} style={style} />;
};
